/**
 * 🆔 UUID UTILS
 * Safe and compatible UUID generation for browsers and environments
 * where crypto.randomUUID might not be available (non-secure contexts, older browsers).
 */

/**
 * Generates a RFC 4122 v4 compliant UUID
 */
export function generateUUID(): string {
  // 1. Try modern crypto.randomUUID if available
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  // 2. Try crypto.getRandomValues (modern browsers, safe contexts)
  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
    return (([1e7] as any) + -1e3 + -4e3 + -8e3 + -1e11).replace(
      /[018]/g,
      (c: number) =>
        (
          c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
    );
  }

  // 3. Fallback to Math.random (not cryptographically secure, but works everywhere)
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
